import { render, staticRenderFns } from "./Privatetrafficconstruction.vue?vue&type=template&id=027c6328&scoped=true"
import script from "./Privatetrafficconstruction.vue?vue&type=script&lang=js"
export * from "./Privatetrafficconstruction.vue?vue&type=script&lang=js"
import style0 from "./Privatetrafficconstruction.vue?vue&type=style&index=0&id=027c6328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027c6328",
  null
  
)

export default component.exports